var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import FeatureItem from './FeatureItem';
export default function ListFeatureIndex(_a) {
    var listFeaturesArray = _a.listFeaturesArray, setActiveContentInformation = _a.setActiveContentInformation, itemActiveFromMobile = _a.itemActiveFromMobile, setActivationFromMobile = _a.setActivationFromMobile, nativeMainRef = _a.nativeMainRef, activeContentInformation = _a.activeContentInformation, background = _a.background;
    var renderFeatureItems = function (listItems) {
        return listItems
            .sort(function (a, b) { return a.order - b.order; })
            .map(function (featureObject, index) { return (_jsx(FeatureItem, { itemActiveFromMobile: itemActiveFromMobile, setActivationFromMobile: setActivationFromMobile, featureObject: featureObject, activeContentInformation: activeContentInformation, setActiveContentInformation: setActiveContentInformation, background: background }, index)); });
    };
    var deactivateAllItems = function () {
        var isMobileViewport = window.visualViewport.width < 1024;
        if (!isMobileViewport) {
            setActiveContentInformation(null);
            setActivationFromMobile(null);
        }
    };
    return (_jsx("div", __assign({ className: "bla1 jobs__column jobs__column__features relative w-full   lg:h-full", ref: nativeMainRef }, { children: _jsx("ul", __assign({ className: "jobs__features__list list-none lg:w-fit", onMouseLeave: deactivateAllItems }, { children: renderFeatureItems(listFeaturesArray) }), void 0) }), void 0));
}
